var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "mku-loading-aniamte" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisiable,
            expression: "isVisiable"
          }
        ],
        staticClass: "mku-loading",
        style: _vm.domStyle
      },
      [
        _c("div", { staticClass: "mku-loading-wrap" }, [
          _c(
            "div",
            { staticClass: "mku-loading__icon" },
            [
              _c("mku-icon", {
                attrs: { type: "loading", size: "36px", color: _vm.iconColor }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.text
            ? _c(
                "div",
                {
                  staticClass: "mku-loading__tip",
                  style: { color: _vm.textColor }
                },
                [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }